import Network from "./Network";

export default Network;
